import { Button, Card, CardHeader, CardPreview, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import logo from "../cosme-widget-logo.png";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../conf/msal/authConfig";
import { Navigate, useLocation } from "react-router-dom";

const useStyles = makeStyles({
    card: {
        ...shorthands.margin("auto"),
        marginTop: "10vh",
        width: "50vw",
        maxWidth: "600px",
        minHeight: "400px",
        ...shorthands.borderRadius("12px"),
        boxShadow: tokens.shadow16,
    },
    header: {
        alignContent: "center",
        ...shorthands.margin("auto"),
        maxHeight: "250px",

    },
    message: {
        ...shorthands.margin("auto"),
        textAlign: "center",
    },
    preview: {
        minHeight: "280px",
    },
    authButton: {
        ...shorthands.margin("auto"),
        marginTop: "50px",
        maxWidth: "100px",
    }
});


export const LoginPage = () => {
    const styles = useStyles();
    const { instance } = useMsal();
    // const isAuthenticated = useIsAuthenticated();
    // const location = useLocation();

    // if (!isAuthenticated && location.pathname === '/login/') {
    //     console.log("not authenticated. view Login page");
    //     return (<LoginPage></LoginPage>)
    // if (isAuthenticated) {
    //     let currentPage: string | null = sessionStorage.getItem("currentPage");
    //     console.log("authenticated. view current page", currentPage);
    //     if (currentPage !== null) {
    //         sessionStorage.removeItem("currentPage");
    //         return (
    //             <Navigate to={currentPage} replace />
    //         );
    //     }
    // }


    const handleLogin = (loginType: string) => {

        if (loginType === "popup") {
            instance.loginPopup(loginRequest).catch((e) => {
                console.log("どのタイミングで呼ばれるのか loginPopup.catch", e);
            }).then((res) => {
                console.log("どのタイミングで呼ばれるのか loginPopup.then", res);
                // let currentPage: string | null = sessionStorage.getItem("currentPage");
                // console.log("loginPopup to redirect.", currentPage);
                // if (currentPage !== null) {

                //     // sessionStorage.removeItem("currentPage");
                //     return (
                //         <Navigate to={currentPage} replace />
                //     );
                // }
            });
        } else if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch((e) => {
                console.log(e);
            }).then((res) => {
                let currentPage: string | null = sessionStorage.getItem("currentPage");
                console.log("login redirect to redirect.", currentPage);
                if (currentPage !== null) {

                    // sessionStorage.removeItem("currentPage");
                    return (
                        <Navigate to={currentPage} replace />
                    );
                }
            });
        }
    };
    return (
        <>

            <Card
                className={styles.card}
                title="ログイン"
            >
                <CardHeader
                    className={styles.header}
                    image={
                        <img src={logo} alt="CosmeWidget" />
                    }
                >
                </CardHeader>
                <CardPreview
                    className={styles.preview}
                >
                    <div className={styles.message}>
                        サインインには<br />
                        ＠mrms365.onmicrosoft.com,<br />
                        または@cosme-widget.comのアカウントが必要です。
                    </div>

                    <div className={styles.authButton}
                    >
                        <Button
                            onClick={() => handleLogin("redirect")}
                        >サインイン</Button>
                    </div>
                </CardPreview>

            </Card>
        </>
    );


}

